enum DefaultPetBreeds {
  Dog = 1, // perro mestizo
  Cat = 363 // gato europeo
}
export default DefaultPetBreeds
